import Vue from 'vue'
import Vuex from 'vuex'

import global from './modules/global'

import auth from './modules/auth'
import dashboard from './modules/dashboard'
import locations from './modules/locations'
import buildings from './modules/buildings'
import users from './modules/users'
import templates from './modules/templates'
import audits from './modules/audits'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    global,
    auth,
    dashboard,
    locations,
    buildings,
    users,
    templates,
    audits
  }
})



// WEBPACK FOOTER //
// ./src/store/store.js